<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="updateDialog"
    max-width="fit-content"
    persistent
  >
    <v-card class="custom-dialog-card">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" size="32" class="mr-2">mdi-domain</v-icon>
        <span class="text-h6 font-weight-bold">Empresas do Cliente</span>
        <v-spacer></v-spacer>
        <v-btn icon flat @click="fecharDialog" class="close-btn" title="Fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-skeleton-loader
          type="table"
          :loading="loading"
          class="mx-auto"
        >
          <div class="v-table-container">
            <v-table class="zebra-table">
              <thead>
                <tr>
                  <th class="font-weight-bold">Razão Social</th>
                  <th class="font-weight-bold">Nome Fantasia</th>
                  <th class="font-weight-bold">CNPJ/CPF</th>
                  <th class="font-weight-bold">Inscrição Estadual</th>
                  <th class="font-weight-bold">Email</th>
                  <th class="font-weight-bold">Telefone</th>
                  <th class="font-weight-bold">CEP</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in empresas_cliente"
                  :key="empresa.codempresacliente"
                >
                  <td>{{ empresa.razao_social }}</td>
                  <td>{{ empresa.nome_fantasia }}</td>
                  <td>{{ empresa.cnpj_cpf }}</td>
                  <td>{{ empresa.inscricao_estadual }}</td>
                  <td>{{ empresa.email }}</td>
                  <td>{{ empresa.telefone }}</td>
                  <td>{{ empresa.cep }}</td>
                </tr>
                <tr v-if="!empresas_cliente || empresas_cliente.length === 0">
                  <td colspan="4" class="text-center text-grey">Nenhuma empresa vinculada.</td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-skeleton-loader>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="fecharDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "../services/api";

export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    codcliente: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    empresas_cliente: [],
  }),
  watch: {
    modelValue(val) {
      if (val && this.codcliente) {
        this.getEmpresasCliente();
      } else if (!val) {
        this.empresas_cliente = []; // Clear data when dialog closes
      }
    },
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:modelValue", val);
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
    },
    async getEmpresasCliente() {
      this.loading = true;
      try {
        const response = await api.get(`/empresacliente/${this.codcliente}`);
        this.empresas_cliente = response.data;
      } catch (error) {
        console.error("Erro ao buscar empresas do cliente:", error);
        this.empresas_cliente = [];
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}

.v-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(25, 118, 210, 0.06);
}

thead {
  background-color: #e3f0ff;
  font-size: 16px;
  color: #1976d2;
}

tbody {
  font-size: 16px;
  background-color: #fafdff;
}

td {
  color: #222;
  background-color: inherit;
  border-bottom: 1px solid #e3e7ed;
}

tr:hover td {
  background-color: #eaf4ff !important;
}

th, td {
  padding: 14px 12px;
}
</style>
